import React from "react";
import { useTranslate, useRecordContext } from "react-admin";

const DebateTitle = ({ isSuggestion }) => {
	const record = useRecordContext();
	const translate = useTranslate();
	
	return (
		<span>
			{isSuggestion
				? translate("resources.debate_suggestions.name", { smart_count: 1 })
				: translate("resources.groups.name", { smart_count: 1 })}{" "}
			{record ? `"${record.name}"` : ""}
		</span>
	);
};

export default DebateTitle;
